import * as React from 'react';
import { Provider } from 'react-redux';
import { createAccountStore } from '../../../Account/store';

interface AccountStoreProviderProps {
	children: React.ReactNode;
}

export const AccountStoreProvider: React.FC<AccountStoreProviderProps> = ({ children }) => {
	const store = React.useMemo(createAccountStore, []);

	return <Provider store={store}>{children}</Provider>;
};

export default AccountStoreProvider;
